import { CoordinatePointModel } from "./coordinate-point";

export class Segment {
  routeDesignation : string;
  startpoint : CoordinatePointModel;
  endpoint: CoordinatePointModel;
  lowerVerticalDistance : number;
  upperVerticalDistance : number;
  lowerVerticalUnitsMeasurement : string;
  upperVerticalUnitsMeasurement : string;
  sequenceNumber : number;
}
